import { render, staticRenderFns } from "./SuperAdminMemberDeleteFeed.vue?vue&type=template&id=1818e1ef&"
import script from "./SuperAdminMemberDeleteFeed.vue?vue&type=script&lang=js&"
export * from "./SuperAdminMemberDeleteFeed.vue?vue&type=script&lang=js&"
import style0 from "./SuperAdminMemberDeleteFeed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports